// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import { connect } from 'react-redux';


// eslint-disable-next-line
import * as MuiCore from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import * as Formatters from '../ui/Formatters';

// import * as Formatters from '../ui/Formatters';
import OutlinedPopover from '../ui/OutlinedPopover';
import classnames from 'classnames';

import * as AccountIcons from '../account/Icons';

import StoredPayment from './StoredPayment';

// import * as coreSelectors from '../core/selectors';
import * as accountSelectors from '../account/selectors';
import * as accountActions from '../account/actions';

const styles = theme => ({
  loadingProgress : {
  },
  loadingLabel : {
    ...theme.typography.body2,
    fontWeight: 'bold',
    marginLeft: 20,
  },
  invoiceTable : {
    borderCollapse: 'collapse',
    '& th' : {
      padding: '3px 20px',
      textAlign: 'left',
    },
    '& td' : {
      padding: '3px 20px',
    },
  },
  money : {
    textAlign: 'right',
  },
  summaryLine : {
    textAlign: 'right',
    fontWeight: 'bold',
  },
  totalLine : {
    borderTop : '1px solid ' + theme.brandingColors.poshBlack,
    borderBottom : '1px solid ' + theme.brandingColors.poshBlack,
  },
  scroll:{
    overflowX:'auto'
  }
});

/*
 * Display open invoices
 */

class Invoices extends Component {

  state = {
  }

  openStripe = () => {
    this.props.setInvoiceOpen(false);
    window.open(this.props.invoice.invoiceUrl);
  }
  
  openStored = () => {
    this.props.setInvoiceOpen(false);
    this.props.setStoredPaymentOpen(true);
  }

  
  render() {
    // eslint-disable-next-line
    const { classes, invoice, invoiceOpen, paymentMethods } = this.props;

    let paymentMethodCount = (paymentMethods.paymentMethods|| []).length;
    
    return(
      <React.Fragment>
        <StoredPayment/>
        <OutlinedPopover open={invoiceOpen && !Boolean(invoice.invoiceId)}
                         maxWidth='sm'
                         onClose={() => this.props.setInvoiceOpen(false)}>
          <MuiCore.Grid container spacing={1} direction='row' alignItems='center'>
            <MuiCore.Grid item className={classes.loadingProgress}>
              <MuiCore.CircularProgress variant='indeterminate'/>
            </MuiCore.Grid>
            <MuiCore.Grid item className={classes.loadingLabel}>
              Retrieving Invoice...
            </MuiCore.Grid>
          </MuiCore.Grid>
        </OutlinedPopover>            
          
        <OutlinedPopover
        classes={{
          detailArea: classes.scroll
        }}
        open={invoiceOpen && Boolean(invoice.invoiceId)}
                         icon={<AccountIcons.InvoiceIcon color='primary' fontSize='large'/>}
                         title={'Invoice ' + invoice.invoiceNumber}
                         maxWidth='md'
                         onClose={() => this.props.setInvoiceOpen(false)}>
          <table className={classes.invoiceTable}>
            <thead>
              <tr>
                <th style={{textWrap:'nowrap'}}>Description</th>
                <th style={{textWrap:'nowrap'}}>Quantity x Unit</th>
                <th style={{textWrap:'nowrap'}}>Start</th>
                <th style={{textWrap:'nowrap'}}>End</th>
                <th style={{textWrap:'nowrap'}} className={classes.money}>Credit</th>
                <th style={{textWrap:'nowrap'}} className={classes.money}>Debit</th>
              </tr>
            </thead>

            <tbody>
              {(invoice.lines || []).filter(line => Boolean(line.invoiceId)).map(line => {
              return(
                <tr key={line.transactionId}>
                  <td>{line.lineItemText}</td>
                  <td>{line.transactionType === 'Invoice' ? (line.invoiceQuantity + ' x ' + Formatters.formatMoney(line.unitPrice, line.currencyCode)) : ''}</td>
                  <td>{Formatters.formatDateNoTZ(line.periodStart)}</td>
                  <td>{Formatters.formatDateNoTZ(line.periodEnd)}</td>
                  <td className={classes.money}>{Formatters.formatMoney(line.credit, line.currencyCode)}</td>
                  <td className={classes.money}>{Formatters.formatMoney(line.debit, line.currencyCode)}</td>
                </tr>);
              })}
              
              <tr>
                <td colSpan='4'></td>
                <td className={classnames(classes.summaryLine, classes.totalLine)}>Invoice Subtotal</td>
                <td className={classnames(classes.money, classes.totalLine)}>{Formatters.formatMoney(invoice.debit, invoice.currencyCode)}</td>
              </tr>
              
              <tr>
                <td colSpan='4'></td>
                <td className={classes.summaryLine}>Previous Balance</td>
                <td className={classes.money}>{Formatters.formatMoney(-invoice.creditForward, invoice.currencyCode)}</td>
              </tr>
              
              <tr>
                <td colSpan='4'></td>
                <td className={classes.summaryLine}>Credits</td>
                <td className={classes.money}>{Formatters.formatMoney(invoice.credits, invoice.currencyCode)}</td>
              </tr>
              
              <tr>
                <td colSpan='4'></td>
                <td className={classes.summaryLine}>Payments</td>
                <td className={classes.money}>{Formatters.formatMoney(invoice.payments, invoice.currencyCode)}</td>
              </tr>

              <tr>
                <td colSpan='4'></td>
                <td className={classnames(classes.summaryLine, classes.totalLine)}>Balance</td>
                <td className={classnames(classes.money, classes.totalLine)}>{Formatters.formatMoney(invoice.balance, invoice.currencyCode)}</td>
              </tr>
            </tbody>
          </table>

          <MuiCore.Grid container spacing={1} style={{width:'100%'}}>
            
            <MuiCore.Hidden xlDown={invoice.status !== 'OPEN'}>
              <MuiCore.Grid item>
                <MuiCore.Button disabled={paymentMethodCount === 0}
                                onClick={this.openStored}>Pay with Stored Method</MuiCore.Button>
              </MuiCore.Grid>
            </MuiCore.Hidden>
            <MuiCore.Hidden xlDown={invoice.status !== 'PAID'}>
              <MuiCore.Grid item>
                <MuiCore.Button onClick={this.openStripe}>Download PDF</MuiCore.Button>
              </MuiCore.Grid>
            </MuiCore.Hidden>

            <MuiCore.Hidden xlDown={invoice.status !== 'PROCESSING'}>
              <MuiCore.Grid item>
                <MuiCore.Typography>A payment on this invoice is processing.</MuiCore.Typography>
              </MuiCore.Grid>
            </MuiCore.Hidden>
          </MuiCore.Grid>
        </OutlinedPopover>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return ({
    invoice : accountSelectors.getInvoice(state),
    invoiceOpen : accountSelectors.getInvoiceOpen(state),
    paymentMethods : accountSelectors.getPaymentMethods(state),
  });
};

const mapDispatchToProps = {
  setInvoiceOpen : accountActions.setInvoiceOpen,
  setStoredPaymentOpen : accountActions.setStoredPaymentOpen,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Invoices));

